import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { BsDropdownModule, CollapseModule, ModalModule } from "ngx-bootstrap";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { UserManageService } from "../../../service/api/jubili/user-manage.service";
import { PipeModule } from "../../../pipe/pipe.module";
import { BuilkSharedModule } from "../shared/shared.module";
import { LoadingModule } from "ngx-loading";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { BsDatepickerModule, PaginationModule } from "ngx-bootstrap";

// ------------------------------------------End Service----------------------------------------------------------------------//

//component
import { CouponSettingComponent } from "./coupon-setting.component";
import { CreateNewCouponComponent } from "./modals/create-new-coupon/create-new-coupon.component";
import { AccessibilityComponent } from "./modals/accessibility/accessibility.component";
import { CreateFreeCouponComponent } from "./modals/create-free-coupon/create-free-coupon.component";
import { CompanyUsedModalComponent } from "./modals/company-used/company-used.component";

@NgModule({
  declarations: [
    CouponSettingComponent,
    CreateNewCouponComponent,
    AccessibilityComponent,
    CreateFreeCouponComponent,
    CompanyUsedModalComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    RouterModule,
    SharedModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    NgbModule.forRoot(),
    PipeModule,
    BuilkSharedModule,
    LoadingModule,
    NgSelectModule,
    NgbDropdownModule,
    BsDatepickerModule.forRoot(),
    PaginationModule
  ],
  exports: [
    CouponSettingComponent,
    CreateNewCouponComponent,
    AccessibilityComponent,
    CreateFreeCouponComponent,
    CompanyUsedModalComponent
  ]
})
export class CouponSettingModule { }
